var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnPremierIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pn-premier-icon2_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 78 70",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 78 70"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pn-premier-icon2_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon2_svg__Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon2_svg__Estate-Agents:-Featured-1",
    transform: "translate(-282 -449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon2_svg__Group-14",
    transform: "translate(282 449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-1",
    d: "M60.8 27.7c0 15.3-12.4 27.7-27.7 27.7S5.3 43.1 5.3 27.7 17.7 0 33 0s27.8 12.4 27.8 27.7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7dce3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 26.4,
    y: 11.9,
    width: 50.2,
    height: 35.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 26.4,
    y: 11.9,
    width: 50.2,
    height: 35.7,
    id: "pn-premier-icon2_svg__mask-2_00000085930459144150730540000017635740458133746095_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000029733739685998496050000016143664606280800140_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-3",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000085930459144150730540000017635740458133746095_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fefefe",
    d: "M26.4 47.5h50.2V11.9H26.4z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000137831073605805526800000005406777497825365635_",
    filterUnits: "userSpaceOnUse",
    x: 1.3,
    y: 22.5,
    width: 50.2,
    height: 35.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.3,
    y: 22.5,
    width: 50.2,
    height: 35.7,
    id: "pn-premier-icon2_svg__mask-2_00000057121815837162326160000012283087206991675063_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000137831073605805526800000005406777497825365635_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000018952919118100763340000009055241282395084725_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-5",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000057121815837162326160000012283087206991675063_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fefefe",
    d: "M1.3 58.1h50.2V22.5H1.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000072982765869374362130000018230908398232936367_",
    filterUnits: "userSpaceOnUse",
    x: 25.4,
    y: 10.9,
    width: 52.2,
    height: 37.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 25.4,
    y: 10.9,
    width: 52.2,
    height: 37.7,
    id: "pn-premier-icon2_svg__mask-2_00000176739669400073883880000007749653312665561216_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000072982765869374362130000018230908398232936367_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000173128863024065389310000010008809274948512447_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Stroke-6",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000176739669400073883880000007749653312665561216_)",
    fill: "none",
    stroke: "#020303",
    strokeWidth: 2,
    d: "M67.4 47.5h9.2V11.9H26.4v6.6"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000145036598686678408210000010480514097774513333_",
    filterUnits: "userSpaceOnUse",
    x: 0.3,
    y: 21.5,
    width: 52.2,
    height: 37.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.3,
    y: 21.5,
    width: 52.2,
    height: 37.7,
    id: "pn-premier-icon2_svg__mask-2_00000041282093575283407910000010183108657168647600_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000145036598686678408210000010480514097774513333_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000150793037687261718210000006342886496324397965_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Stroke-7",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000041282093575283407910000010183108657168647600_)",
    fill: "none",
    stroke: "#020303",
    strokeWidth: 2,
    d: "M51.5 29.1v-6.6H1.3v35.6h9.3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000109025070614603496860000008693883196406578108_",
    filterUnits: "userSpaceOnUse",
    x: 14.5,
    y: 33,
    width: 48.9,
    height: 35.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 14.5,
    y: 33,
    width: 48.9,
    height: 35.7,
    id: "pn-premier-icon2_svg__mask-2_00000111170707899756830490000017500866410845448584_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000109025070614603496860000008693883196406578108_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000177455945074290987440000002782046391826791069_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-8",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000111170707899756830490000017500866410845448584_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fefefe",
    d: "M14.5 68.7h48.9V33H14.5z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000027602251241496282590000016713909427733576094_",
    filterUnits: "userSpaceOnUse",
    x: 13.5,
    y: 32,
    width: 50.9,
    height: 37.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.5,
    y: 32,
    width: 50.9,
    height: 37.7,
    id: "pn-premier-icon2_svg__mask-2_00000065060368609317252630000018057363186909552057_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000027602251241496282590000016713909427733576094_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000018234810810013143130000004408814057212082601_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Stroke-9",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000065060368609317252630000018057363186909552057_)",
    fill: "none",
    stroke: "#020303",
    strokeWidth: 2,
    d: "M14.5 68.7h48.9V33H14.5z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000089565044521462836720000007996321986444031140_",
    filterUnits: "userSpaceOnUse",
    x: 47.5,
    y: 39.6,
    width: 7.9,
    height: 7.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 47.5,
    y: 39.6,
    width: 7.9,
    height: 7.9,
    id: "pn-premier-icon2_svg__mask-2_00000043445731126825937490000017764143772392819870_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000089565044521462836720000007996321986444031140_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000177467239159349550150000004374245317129318818_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-10",
    d: "M55.5 43.6c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000043445731126825937490000017764143772392819870_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000097500415751640451160000001170601780058251437_",
    filterUnits: "userSpaceOnUse",
    x: 46.5,
    y: 38.6,
    width: 9.9,
    height: 9.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 46.5,
    y: 38.6,
    width: 9.9,
    height: 9.9,
    id: "pn-premier-icon2_svg__mask-2_00000031171659094511838050000013350882025678209672_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000097500415751640451160000001170601780058251437_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000091002230667066357100000012369085490431037353_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Stroke-11",
    d: "M55.5 43.6c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000031171659094511838050000013350882025678209672_)",
    fill: "none",
    stroke: "#020303",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000167396904443456298070000002064894955113725355_",
    filterUnits: "userSpaceOnUse",
    x: 14.5,
    y: 47.5,
    width: 47.5,
    height: 21.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 14.5,
    y: 47.5,
    width: 47.5,
    height: 21.1,
    id: "pn-premier-icon2_svg__mask-2_00000139262524981087314040000013096012311365077155_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000167396904443456298070000002064894955113725355_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000054975861269132394840000000390054943990987696_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Fill-12",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000139262524981087314040000013096012311365077155_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ea4a6d",
    d: "M46.2 52.8l-4.6 4.7-9.9-10-17.2 17.2v4h47.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000124160344651497184910000017306232160418342828_",
    filterUnits: "userSpaceOnUse",
    x: 13.5,
    y: 46.1,
    width: 51,
    height: 23.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.5,
    y: 46.1,
    width: 51,
    height: 23.5,
    id: "pn-premier-icon2_svg__mask-2_00000022561425353257353360000008084819734013568152_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pn-premier-icon2_svg__Adobe_OpacityMaskFilter_00000124160344651497184910000017306232160418342828_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__path-1_00000130619680955028888000000007584074084359066259_",
    className: "pn-premier-icon2_svg__st2",
    d: "M0 70h77.9V0H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon2_svg__Stroke-13",
    mask: "url(#pn-premier-icon2_svg__mask-2_00000022561425353257353360000008084819734013568152_)",
    fill: "none",
    stroke: "#020303",
    strokeWidth: 2,
    d: "M46.2 62.1L31.7 47.5 14.5 64.7v4h47.6L46.2 52.8l-3.9 4"
  }))))));
}
export default SvgPnPremierIcon2;